module.exports = __webpack_public_path__ + "img/337.a929fd2.png";